import PDFServiceContent from "../../../../src/pages/pricing/pdf-services-content.md";
import * as React from 'react';
export default {
  PDFServiceContent,
  React
};